<template>
  <b-modal :active="value" has-modal-card @close="close()">
    <form action="">
      <div class="modal-card" style="width: 100%; min-width: 300px">
        <header class="modal-card-head">
          <p
            class="modal-card-title"
            style="color: whitesmoke; text-align: left"
          >
            添付一覧
          </p>
        </header>
        <section class="modal-card-body">
          <ul>
            <li v-for="file in files" :key="file.fileName">
              ・
              <g-link v-model="file.fileName" @click="downloadFile(file)"> </g-link>
            </li>
          </ul>
        </section>

        <footer class="modal-card-foot">
          <button class="button" type="button" @click="close()">閉じる</button>
        </footer>
      </div>
    </form>
  </b-modal>
</template>

<script>
export default {
  name: "Files",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    files: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },

  methods: {
    downloadFile: function (file) {
      this.$emit("download-file", file);
    },

    close: function () {
      this.$emit("input", false);
      return;
    },
  },

  data() {
    return {};
  },

  watch: {},

  filters: {},

};
</script>



// WEBPACK FOOTER //
// src/components/common/Files.vue